<nz-layout>
  <nz-header>
    <nz-row nzJustify="end">
      <nz-col [nzSpan]="collapsed ? 21 : 24" style="justify-content: end">
        <button (click)="onColapse.emit()" nz-button nzType="text" nzShape="circle">
          <mat-icon fontSet="material-icons-outlined">
            {{ collapsed ? "arrow_forward_ios" : "arrow_back_ios" }}
          </mat-icon>
        </button>
      </nz-col>
    </nz-row>

    <nz-row nzJustify="center" *ngIf="!(isLoading$ | async)">
      <nz-col *ngIf="user" class="fade-in">
        <nz-row>
          <nz-col>
            <az_avatar [size]="collapsed ? 40 : 120" icon="user" [src]="user.photo" background="#fde3cf" />
          </nz-col>

          <nz-col nzSpan="24">
            <h1 *ngIf="!collapsed">
              {{ user.name }}
            </h1>
          </nz-col>

          <nz-col nzSpan="24">
            <h4 *ngIf="!collapsed">
              {{ user.RoleModel.name }}
            </h4>
          </nz-col>
        </nz-row>
      </nz-col>

      <nz-col *ngIf="!user" class="fade-in">
        <nz-row>
          <nz-col nzSpan="24">
            <az_avatar [size]="collapsed ? 40 : 120" [icon]="'user'" [src]="'assets/images/google.svg'"
              [background]="'#f56a00'" [color]="'#fff'" />
          </nz-col>
          <nz-col>
            @if(user) {
            <h4 *ngIf="!collapsed" class="fade-in">
              {{ "Não encontrado" }}
            </h4>
            }
          </nz-col>
        </nz-row>
      </nz-col>
    </nz-row>

    <nz-row *ngIf="isLoading$ | async" nzJustify="center">
      <nz-col nzSpan="20">
        <nz-skeleton-element nzType="avatar" [nzActive]="true" [nzShape]="'circle'"
          [nzSize]="collapsed ? 40 : 120"></nz-skeleton-element>
      </nz-col>

      <nz-col nzSpan="20" *ngIf="!collapsed">
        <nz-skeleton-element nzType="input" [nzActive]="true" [nzSize]="'large'"></nz-skeleton-element>
      </nz-col>

      <nz-col nzSpan="20" *ngIf="!collapsed">
        <nz-skeleton-element nzType="button" [nzActive]="true" [nzSize]="'default'"></nz-skeleton-element>
      </nz-col>
    </nz-row>
  </nz-header>

  <nz-content>
    <nz-skeleton [nzActive]="true" [nzAvatar]="false" *ngIf="isLoading$ | async" [nzParagraph]="{ rows: 4 }" />

    <div *ngIf="!(isLoading$ | async)">
      <ng-container *ngTemplateOutlet="menuGroup; context: { menu: menu }" />
    </div>
  </nz-content>

  <nz-footer>
    <nz-row nzAlign="middle">
      <nz-col nzFlex="auto" class="fade-in" *ngIf="!collapsed">
        <img width="160px" height="auto" src="/assets/images/square-logo.png" alt="Suprema logo" />
      </nz-col>

      <nz-col nzFlex="auto" class="fade-in" *ngIf="collapsed" style="padding: 7px">
        <img width="33px" src="/assets/images/square-logo.png" alt="Suprema logo" />
      </nz-col>

      <nz-col class="button">
        <button nz-button nzType="text" nzShape="circle" routerLink="/config">
          <mat-icon fontSet="material-icons-outlined">
            settings-outlined
          </mat-icon>
        </button>
      </nz-col>

      <nz-col class="button" *ngIf="!collapsed">
        <button (click)="logout()" nz-button nzType="text" nzShape="circle">
          <mat-icon fontSet="material-icons-outlined">logout</mat-icon>
        </button>
      </nz-col>
    </nz-row>
    <nz-row [nzAlign]="'bottom'" [nzJustify]="'end'">
      <h6><b>Suprema Ltda</b> {{version}}</h6>
    </nz-row>
  </nz-footer>
</nz-layout>

<ng-template #menuItem let-item="item">
  <nz-row nzAlign="middle" nzJustify="space-evenly">
    <nz-col nz-col>
      <mat-icon fontSet="material-icons-outlined">{{ item.icon }}</mat-icon>
    </nz-col>

    <nz-col nz-col nzFlex="auto" *ngIf="!collapsed">
      <h5>{{ item.label }}</h5>
    </nz-col>

    <nz-col nz-col nzSpan="4" nzOffset="4" *ngIf="!collapsed">
      <mat-icon fontSet="material-icons-outlined">{{
        "chevron_right"
        }}</mat-icon>
    </nz-col>
  </nz-row>
</ng-template>

<ng-template #menuGroup let-menu="menu">
  <ul nz-menu nzMode="vertical">
    <ng-container *ngFor="let item of menu">
      <ng-container *ngIf="!item.hidden">
        <ng-container *ngIf="!item.subMenu?.length; else submenuTemplate">
          <li [nzDisabled]="item.disabled || false" [nzMatchRouter]="true" routerLink="{{ item.path }}" nz-menu-item>
            <ng-container *ngTemplateOutlet="menuItem; context: { item: item }" />
          </li>
        </ng-container>

        <ng-template #submenuTemplate>
          <ng-template #title>
            <nz-row nzAlign="middle" class="f-height">
              <nz-col nz-col>
                <mat-icon fontSet="material-icons-outlined">{{
                  item.icon
                  }}</mat-icon>
              </nz-col>

              <nz-col nz-col nzFlex="auto" *ngIf="!collapsed">
                <h5>{{ item.label }}</h5>
              </nz-col>

            </nz-row></ng-template>

          <li [nzDisabled]="item.disabled || false" nz-submenu [nzTitle]="title" style="color: white">
            <ng-container *ngTemplateOutlet="menuGroup; context: { menu: item.subMenu }"></ng-container>
          </li>
        </ng-template>
      </ng-container>
    </ng-container>
  </ul>
</ng-template>
